import { render, staticRenderFns } from "./BuyTab4.vue?vue&type=template&id=4c5d6b0c&scoped=true&lang=pug&"
import script from "./BuyTab4.vue?vue&type=script&lang=js&"
export * from "./BuyTab4.vue?vue&type=script&lang=js&"
import style0 from "./BuyTab4.vue?vue&type=style&index=0&id=4c5d6b0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d6b0c",
  null
  
)

export default component.exports